module.exports = __webpack_public_path__ + "img/garbage.e6e084f5.svg";